import { Store } from 'react-notifications-component'
import { AppDispatch } from '@src/store/store'
import { userApi } from '@src/api/user-api'
import {
  setFieldValue,
  setPoints,
  setProfile,
  successFieldChange,
  setElectronicChips,
  setProductGroup,
  setPurchases,
  setSuccessChangePassword, deleteProfileStatus,
} from '@src/store/ducks/user/reducer'
import {
  setConfirmAction, setConfirmPhone, setIsLoading,
} from '@src/store/ducks/auth/reducer'
import moment from 'moment'

export const getPoints = () => async (dispatch: AppDispatch) => {
  dispatch(setIsLoading(true))
  try {
    const result = await userApi.myPoints()
    dispatch(setPoints(result))
  } catch (err: any) {
    console.error(err)
  } finally {
    dispatch(setIsLoading(false))
  }
}
export const getProfile = () => async (dispatch: AppDispatch) => {
  dispatch(setIsLoading(true))
  try {
    const result = await userApi.profile()
    dispatch(setProfile(result))
  } catch (err: any) {
    console.error(err)
  } finally {
    dispatch(setIsLoading(false))
  }
}
export const setField = (nameField: string, value: string) => async (dispatch: AppDispatch) => {
  dispatch(setIsLoading(true))
  try {
    if (nameField === 'phone') {
      dispatch(setConfirmAction(true))
      await userApi.setNewValueField(nameField, value)
      dispatch(setConfirmPhone(value))
    } else {
      await userApi.setNewValueField(nameField, value)
      dispatch(setFieldValue({ name: nameField, value }))
      if (nameField === 'birthday') {
        dispatch(setFieldValue({ name: 'lastBirthdayUpdate', value: moment().format() }))
      }
      dispatch(successFieldChange(true))
      Store.addNotification({
        message: 'Ваши данные успешно изменены!',
        type: 'success',
        insert: 'top',
        container: 'top-right',
        animationIn: ['animate__animated', 'animate__fadeIn'],
        animationOut: ['animate__animated', 'animate__fadeOut'],
        dismiss: {
          duration: 3000,
        },
      })
    }
  } catch (err: any) {
    console.error(err)
    Store.addNotification({
      message: 'Произошла ошибка!',
      type: 'danger',
      insert: 'top',
      container: 'top-right',
      animationIn: ['animate__animated', 'animate__fadeIn'],
      animationOut: ['animate__animated', 'animate__fadeOut'],
      dismiss: {
        duration: 3000,
      },
    })
  } finally {
    dispatch(setIsLoading(false))
  }
}
export const getPurchases = (dateStart: string, dateEnd: string, page: number) => async (dispatch: AppDispatch) => {
  dispatch(setIsLoading(true))
  try {
    const result = await userApi.myPurchases(dateStart, dateEnd, page)
    dispatch(setPurchases(result))
  } catch (err: any) {
    console.error(err)
  } finally {
    dispatch(setIsLoading(false))
  }
}
export const getChips = () => async (dispatch: AppDispatch) => {
  dispatch(setIsLoading(true))
  try {
    const result = await userApi.myChips()
    dispatch(setElectronicChips(result))
  } catch (err: any) {
    console.error(err)
  } finally {
    dispatch(setIsLoading(false))
  }
}
export const getProductGroup = () => async (dispatch: AppDispatch) => {
  dispatch(setIsLoading(true))
  try {
    const result = await userApi.myProductGroup()
    dispatch(setProductGroup(result))
  } catch (err: any) {
    console.error(err)
  } finally {
    dispatch(setIsLoading(false))
  }
}
export const newProductGroup = (id: number) => async () => {
  try {
    await userApi.changeProductGroup(id)
  } catch (err: any) {
    console.error(err)
  }
}
export const getChangePassword = (password: string) => async (dispatch: AppDispatch) => {
  dispatch(setIsLoading(true))
  try {
    const result = await userApi.changePassword(password)
    dispatch(setSuccessChangePassword(result))
  } catch (err: any) {
    console.error(err)
  } finally {
    dispatch(setIsLoading(false))
  }
}
export const deleteUser = () => async (dispatch: AppDispatch) => {
  dispatch(setIsLoading(true))
  try {
    const result = await userApi.deleteUser()
    console.log('result', result)
    // dispatch(logoutAC())
    // dispatch(setIsInitialized())
    dispatch(deleteProfileStatus(result.success))
    window.location.reload()
  } catch (err) {
    console.error(err)
  } finally {
    dispatch(setIsLoading(false))
  }
}
